// extracted by mini-css-extract-plugin
export default {"feed":"styles-module__feed__src-labstep-web-components-PurchaseOrder-List-_h2Ysx"};